module.exports = __webpack_public_path__ + "img/6.fbd67c4d.jpg";